export default "__VITE_ASSET__KbgZ8bic__"